var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.firstRendered) ? _c('div', [_c('div', {
    staticClass: "filter-condition box-shadow-small border-radius"
  }, [_c('div', {
    staticClass: "search-box"
  }, [_c('el-button', {
    staticClass: "search-hd",
    attrs: {
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.searchKeyword(_vm.keyword)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search-bd"
  }, [_c('search-bar', {
    attrs: {
      "ajaxSearch": false,
      "placeholder": "请输入职位名称、职位编号、招聘HR进行搜索"
    },
    on: {
      "enter-key": _vm.searchKeyword,
      "select": _vm.searchKeyword
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  })], 1)], 1), _vm._v(" "), _c('filter-panel', {
    ref: "condition",
    on: {
      "params-change": _vm.handleParmasChange
    }
  }, _vm._l((_vm.filterConf), function(item, index) {
    return _c('filter-panel-item', {
      key: index,
      ref: item.name,
      refInFor: true,
      attrs: {
        "label": item.label,
        "mode": item.mode,
        "visible": item.visible,
        "name": item.name,
        "data": item.data,
        "initValue": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-result background-white box-shadow-small border-radius"
  }, [_c('div', {
    staticClass: "filter-result-header mt-15 clearfix"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-plus",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.addPositionDialog.show()
      }
    }
  }, [_vm._v("新建职位")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [(_vm.lists.length) ? _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "end"
    }
  }, [_c('p', {
    staticClass: "mr-25"
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "on-value": 1,
      "off-value": 0
    },
    on: {
      "change": _vm.switchChange
    },
    model: {
      value: (_vm.switchValue),
      callback: function($$v) {
        _vm.switchValue = $$v
      },
      expression: "switchValue"
    }
  }), _vm._v("\n                            多人面试无须全部评价\n                            "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "开启后，多人面试中，若有其中一个面试官已提交评价，则其他面试官无须再评价",
      "placement": "top"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "icon": "el-icon-information"
    }
  })], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-daiding color-warning",
      "type": "warning",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.toggleState(_vm.idStr, '0')
      }
    }
  }, [_vm._v("草稿\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-queding color-success",
      "type": "success",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.toggleState(_vm.idStr, '2')
      }
    }
  }, [_vm._v("暂停\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-daiding color-warning",
      "type": "warning",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.toggleState(_vm.idStr, '3')
      }
    }
  }, [_vm._v("待审核\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-guanbi color-danger",
      "type": "danger",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.remove(_vm.idStr)
      }
    }
  }, [_vm._v("删除\n                        ")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.partialLoading),
      expression: "partialLoading"
    }]
  }, [_c('empty-tip', {
    attrs: {
      "show": !_vm.lists.length
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-list mt-20"
  }, [(_vm.lists.length) ? _c('el-table', {
    attrs: {
      "data": _vm.lists
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职位编号",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.code) + "\n                        ")]
      }
    }], null, false, 4143751376)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职位名称",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "color": "#20A0FF"
          },
          attrs: {
            "href": "javascript:;"
          },
          on: {
            "click": function($event) {
              return _vm.$refs.preview.show(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }], null, false, 722025121)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "工作地点",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.cityNames) + "\n                        ")]
      }
    }], null, false, 2814164654)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "招聘人数",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.recruitCount) + "\n                        ")]
      }
    }], null, false, 1649549808)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "招聘范围",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_PROPERTY_TYPE', scope.row.property)) + "\n                        ")]
      }
    }], null, false, 3894185378)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "门户展示",
      "show-overflow-tooltip": true,
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.showInDesk == 1 ? '是' : '否') + "\n                        ")]
      }
    }], null, false, 3889521821)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "内推职位",
      "show-overflow-tooltip": true,
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_YES_OR_NO', scope.row.recommendable)) + "\n                        ")]
      }
    }], null, false, 403392328)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "开始时间",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.dateFormat(scope.row.onlineDate)) + "\n                        ")]
      }
    }], null, false, 2541078416)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "暂停时间",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.dateFormat(scope.row.offlineDate)) + "\n                        ")]
      }
    }], null, false, 3818310398)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "招聘部门",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.deptNames) + "\n                        ")]
      }
    }], null, false, 3474352204)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "审核时间",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.dateFormat(scope.row.apploveTime) || '-') + "\n                        ")]
      }
    }], null, false, 4148793826)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "招聘HR",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.mark) + "\n                        ")]
      }
    }], null, false, 4193532616)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作人",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.followUpName) + "\n                        ")]
      }
    }], null, false, 4288148430)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_POSITION_STATE', scope.row.state)) + "\n                        ")]
      }
    }], null, false, 2223185923)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "class-name": "no-wrap",
      "min-width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.$refs.addPositionDialog.show(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.remove(scope.row.id)
            }
          }
        }, [_c('span', {
          staticClass: "color-danger"
        }, [_vm._v("删除")])]), _vm._v(" "), _c('el-dropdown', {
          staticClass: "ml-10",
          attrs: {
            "hide-on-click": false
          }
        }, [_c('span', {
          staticClass: "el-dropdown-link"
        }, [_vm._v("更多")]), _vm._v(" "), _c('el-dropdown-menu', {
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [_c('el-dropdown-item', {
          nativeOn: {
            "click": function($event) {
              return _vm.toggleState(scope.row.id, 0)
            }
          }
        }, [_c('i', {
          staticClass: "mr-10 el-icon-my-caogao color-success"
        }), _vm._v("草稿\n                                    ")]), _vm._v(" "), _c('el-dropdown-item', {
          nativeOn: {
            "click": function($event) {
              return _vm.toggleState(scope.row.id, 2)
            }
          }
        }, [_c('i', {
          staticClass: "mr-10 el-icon-my-zanting color-warning"
        }), _vm._v("暂停\n                                    ")]), _vm._v(" "), _c('el-dropdown-item', {
          nativeOn: {
            "click": function($event) {
              return _vm.toggleState(scope.row.id, 3)
            }
          }
        }, [_c('i', {
          staticClass: "mr-10 el-icon-my-daiding color-warning"
        }), _vm._v("待审核\n                                    ")])], 1)], 1)]
      }
    }], null, false, 4239388332)
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.lists.length) ? _c('el-pagination', {
    staticClass: "text-center mt-20 mb-20",
    attrs: {
      "current-page": _vm.pagination.pageIndex,
      "page-size": _vm.pagination.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pagination.recordCounts
    },
    on: {
      "size-change": _vm.pageSizeChange,
      "current-change": _vm.pageIndexChange
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('Add-Position-Dialog', {
    ref: "addPositionDialog",
    on: {
      "reload": _vm.fetchData
    }
  }), _vm._v(" "), _c('preview-position', {
    ref: "preview"
  })], 1) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e1c2817"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/position/positionList.vue
// module id = null
// module chunks = 